import React from 'react'
import { useNavigate } from 'react-router'

import useDidMount from '@divvy-web/hooks.usedidmount'
import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'
import { logInfo } from '@sputnik/utils/loggerUtils'

interface ResumeApplicationBannerProps {
  salesforceCreditId: string
}

// This status shows if status is not_started or if in_progress without savedSections
const ResumeApplicationBanner = ({ salesforceCreditId }: ResumeApplicationBannerProps) => {
  const navigate = useNavigate()
  const { track } = useWebTracking()

  useDidMount(() => {
    track('se_signup__application_dashboard_action_needed_resume_application__presented')
  })

  const onResumeApplicationClick = () => {
    logInfo('onResumeApplicationClick', {
      attributes: {
        creditAppId: salesforceCreditId,
        result: 'Clicked resume application from banner',
      },
      eventName: 'onResumeApplicationClick',
    })

    navigate(`/app/${salesforceCreditId}/${PATHNAME_CONSTS.NAME_AND_OWNERSHIP_PATH}`)
  }

  return (
    <div className='dd-privacy-allow'>
      <StatusBanner
        bannerType={BannerType.Informative}
        subtext={
          <FormattedMessage
            defaultMessage="You're almost there! <link>Resume your application</link>"
            id='sputnik.ResumeApplicationBanner__dezVS5'
            values={{
              link: (chunks) => (
                <TextLink
                  size={TextLinkSizes.SMALL}
                  onClick={() => {
                    track('se_signup__application_dashboard_action_needed_resume_your_application__fired')
                    onResumeApplicationClick()
                  }}
                >
                  {chunks}
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Resume application'
            id='sputnik.ResumeApplicationBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default ResumeApplicationBanner
